// extracted by mini-css-extract-plugin
export default {"error":"Select_error__uPWs-"};